import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { QuoteModel } from '@amfam/policy/models';

@Component({
  selector: 'premium-detail',
  templateUrl: './premium-detail.component.html',
  styleUrls: ['./premium-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PremiumDetailComponent implements OnInit {
  @Input() quote: QuoteModel;
  @Input() hideAsterisk = false;
  public quoteDescription: string;

  constructor() {}

  ngOnInit() {
    if (this.quote && this.quote.description) {
      this.quoteDescription = this.quote.description;
    }
  }
}
